module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/common/user-card-context/user-card-context.component.scss
// module id = ./src/app/modules/common-module/common/user-card-context/user-card-context.component.scss
// module chunks = 9